import { service } from '@ember/service';
import Component from '@glimmer/component';

import type { Service } from 'webapp-types';

import ToolTipWithIconComponent from 'webapp/components/tool-tip-with-icon';

interface Args {
	timezone?: string;
}

export default class TimezoneDescriptionComponent extends Component<Args> {
	@service('current-user') declare currentUserService: Service.CurrentUser;
	@service('constants') declare constantsService: Service.Constants;

	get timezone(): string {
		return this.args.timezone || this.currentUserService.model!.timezone;
	}

	get timezoneLabel(): string {
		return (
			this.constantsService.timezones.find((item) => item.value === this.timezone)?.label ||
			''
		);
	}
	<template>
		<div class="row timezone-description">
			<label>Time zone:</label>
			<div class="right">
				<strong>{{this.timezoneLabel}}</strong>
				<ToolTipWithIconComponent
					@text="You can change time zone under “My profile”"
					@maxWidth={{250}}
				/>
			</div>
		</div>
	</template>
}
